var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CollectivityPicker',{attrs:{"is-loading":_vm.loadingCollectivities > 0,"get-collectivities":_vm.fetchCollectivities,"collectivities":_vm.collectivities,"stay-on-page":_vm.stayOnPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }